module.exports = __webpack_public_path__ + "static/referans-hillspet-92710a05c7427f9cda1a62683483eec3.png";